/* ─────────────────────────────────────────
   section-main-product.js
───────────────────────────────────────── */

(function () {
  'use strict';

  /* ── Shared embed URL builder ── */
  function getEmbedUrl(url) {
    let m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0';
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return url;
  }

  /* ── VARIANT SELECTOR ── */
  function initVariants(section) {
    const variantSelect = document.getElementById('ProductSelect-' + section.dataset.sectionId);
    if (!variantSelect) return;

    const priceEl      = document.getElementById('ProductPrice-' + section.dataset.sectionId);
    const atcBtn       = section.querySelector('.product-atc-btn');
    const variantInput = document.getElementById('ProductVariantId-' + section.dataset.sectionId);

    const selectedOptions = [];

    function findMatchingVariant() {
      return Array.from(variantSelect.options).find(opt => {
        const parts = opt.dataset.title.split(' / ');
        return parts.every((v, i) => v === selectedOptions[i]);
      });
    }

    function updateDropdownLabel() {
      // Pills show selection via is-active class — no label to update
    }

    function updatePriceDisplay(opt) {
      if (!priceEl || !opt) return;
      const price        = parseInt(opt.dataset.price, 10);
      const comparePrice = parseInt(opt.dataset.comparePrice, 10);
      const formatter    = window.Shopify && Shopify.formatMoney
        ? (cents) => Shopify.formatMoney(cents, window.theme && theme.moneyFormat)
        : (cents) => '$' + (cents / 100).toFixed(2);

      if (comparePrice && comparePrice > price) {
        const savings = Math.round((comparePrice - price) / comparePrice * 100);
        priceEl.innerHTML =
          '<span class="product-price__sale">'    + formatter(price)        + '</span>' +
          '<span class="product-price__compare">' + formatter(comparePrice) + '</span>' +
          '<span class="product-price__badge">SAVE ' + savings + '%</span>';
      } else {
        priceEl.innerHTML = '<span class="product-price__regular">' + formatter(price) + '</span>';
      }
    }

    function updateAtcBtn(opt) {
      if (!atcBtn || !opt) return;
      const available    = opt.dataset.available === 'true';
      atcBtn.disabled    = !available;
      atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    function updateGallery(opt) {
      if (!opt || !opt.dataset.featuredImage) return;
      const thumb = section.querySelector('.product-gallery__thumb[data-media-id="' + opt.dataset.featuredImage + '"]');
      if (thumb) thumb.click();
    }

    function updateHiddenInput(opt) {
      if (variantInput && opt) variantInput.value = opt.value;
      if (opt) opt.selected = true;
    }

    function onOptionSelected(optionIndex, value) {
      selectedOptions[optionIndex] = value;
      updateDropdownLabel(optionIndex, value);
      const match = findMatchingVariant();
      if (!match) return;
      updatePriceDisplay(match);
      updateAtcBtn(match);
      updateHiddenInput(match);
      updateGallery(match);
      if (window.history && history.replaceState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', match.value);
        history.replaceState({}, '', url);
      }
    }

    section.addEventListener('click', function (e) {
      const pill = e.target.closest('.variant-pill');
      if (!pill) return;
      e.preventDefault();

      const optionIndex = parseInt(pill.dataset.optionIndex, 10);
      const value       = pill.dataset.value;

      // Update active state within this option group only
      pill.closest('.variant-option-group__pills')
        .querySelectorAll('.variant-pill')
        .forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');

      onOptionSelected(optionIndex, value);
    });

    // Initialise selectedOptions from currently selected variant
    const currentOpt = Array.from(variantSelect.options).find(o => o.selected);
    if (currentOpt) {
      currentOpt.dataset.title.split(' / ').forEach((v, i) => { selectedOptions[i] = v; });
    }
  }

  /* ── GALLERY ── */
  function initGallery(section) {
    const thumbs  = Array.from(section.querySelectorAll('.product-gallery__thumb'));
    const slides  = Array.from(section.querySelectorAll('.product-gallery__slide'));
    const prevBtn = section.querySelector('.product-gallery__arrow--prev');
    const nextBtn = section.querySelector('.product-gallery__arrow--next');

    if (!slides.length) return;

    let currentIndex = slides.findIndex(s => s.classList.contains('is-active'));
    if (currentIndex < 0) currentIndex = 0;

    function goTo(idx) {
      slides.forEach(s => s.classList.remove('is-active'));
      thumbs.forEach(t => t.classList.remove('is-active'));
      currentIndex = (idx + slides.length) % slides.length;
      slides[currentIndex].classList.add('is-active');
      if (thumbs[currentIndex]) {
        thumbs[currentIndex].classList.add('is-active');
        thumbs[currentIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

    const main = section.querySelector('.product-gallery__main');
    if (main) {
      let touchStartX = 0, touchDeltaX = 0;
      main.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; touchDeltaX = 0; }, { passive: true });
      main.addEventListener('touchmove',  e => { touchDeltaX = e.touches[0].clientX - touchStartX; }, { passive: true });
      main.addEventListener('touchend',   () => { if (touchDeltaX < -50) goTo(currentIndex + 1); if (touchDeltaX > 50) goTo(currentIndex - 1); });
    }
  }

  /* ── IMAGE ZOOM — click to toggle, mouse pans when zoomed ── */
  function initZoom(section) {
    const main = section.querySelector('.product-gallery__main');
    if (!main) return;

    let isZoomed = false;

    function getActiveWrap() {
      const slide = main.querySelector('.product-gallery__slide.is-active');
      return slide ? slide.querySelector('.product-gallery__zoom-wrap') : null;
    }

    function getActiveImg() {
      const wrap = getActiveWrap();
      return wrap ? wrap.querySelector('.product-gallery__image') : null;
    }

    function zoomIn(e) {
      const wrap = getActiveWrap(), img = getActiveImg();
      if (!wrap || !img) return;
      const rect = wrap.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width)  * 100;
      const y = ((e.clientY - rect.top)  / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform       = 'scale(1.85)';
      wrap.classList.add('is-zoomed');
      isZoomed = true;
    }

    function zoomOut() {
      const wrap = getActiveWrap(), img = getActiveImg();
      if (!wrap || !img) return;
      img.style.transform       = '';
      img.style.transformOrigin = '';
      wrap.classList.remove('is-zoomed');
      isZoomed = false;
    }

    main.addEventListener('click', e => { isZoomed ? zoomOut() : zoomIn(e); });

    main.addEventListener('mousemove', e => {
      if (!isZoomed) return;
      const wrap = getActiveWrap(), img = getActiveImg();
      if (!wrap || !img) return;
      const rect = wrap.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - rect.left) / rect.width * 100) + '% ' + ((e.clientY - rect.top) / rect.height * 100) + '%';
    });

    main.addEventListener('mouseleave', () => { if (isZoomed) zoomOut(); });

    section.querySelectorAll('.product-gallery__thumb, .product-gallery__arrow').forEach(el => {
      el.addEventListener('click', () => { if (isZoomed) zoomOut(); });
    });

    main.addEventListener('touchstart', () => { if (isZoomed) zoomOut(); }, { passive: true });
  }

  /* ── QUANTITY ── */
  function initQty(section) {
    const input = section.querySelector('.product-qty__input');
    if (!input) return;
    section.querySelectorAll('.product-qty__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const cur = parseInt(input.value, 10) || 1;
        input.value = btn.dataset.action === 'plus' ? cur + 1 : Math.max(1, cur - 1);
      });
    });
  }

    /* ── READ MORE — inline at end of text, scrolls to Description accordion ── */
  function initReadMore(section) {
    const btn    = section.querySelector('.product-short-desc__readmore');
    const textEl = section.querySelector('.product-short-desc__text');
    if (!btn || !textEl) return;

    const paras  = textEl.querySelectorAll('p');
    const lastEl = paras.length ? paras[paras.length - 1] : textEl;
    lastEl.appendChild(btn);

    btn.addEventListener('click', () => {
      const accBody = document.getElementById(btn.dataset.targetAccordion);
      const accItem = accBody ? accBody.closest('[data-accordion]') : null;
      const trigger = accItem ? accItem.querySelector('.acc-trigger') : null;
      if (!accItem || !trigger) return;

      if (!accItem.classList.contains('is-open')) trigger.click();

      setTimeout(() => accItem.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
    });
  }

    /* ── ACCORDIONS ── */
  function initAccordions(section) {
    const items = Array.from(section.querySelectorAll('[data-accordion]'));

    function setState(item, isOpen) {
      item.classList.toggle('is-open', isOpen);
      const trigger = item.querySelector('.acc-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    items.forEach(item => {
      const trigger = item.querySelector('.acc-trigger');
      const body    = item.querySelector('.acc-body');
      if (!trigger || !body) return;

      body.removeAttribute('hidden');
      setState(item, item.classList.contains('is-open'));

      trigger.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-open');
        items.forEach(i => setState(i, false));
        if (!wasOpen) setState(item, true);
      });
    });
  }

  /* ── FEATURED VIDEO (inline embed) ── */
  function initFeatureVideo(section) {
    const widget  = section.querySelector('.product-feature-video');
    if (!widget) return;
    const playBtn = widget.querySelector('.product-feature-video__play');
    const poster  = widget.querySelector('.product-feature-video__poster');
    const embed   = widget.querySelector('.product-feature-video__embed');
    const url     = widget.dataset.videoUrl;
    if (!playBtn || !url) return;
    playBtn.addEventListener('click', () => {
      embed.innerHTML = '<iframe src="' + getEmbedUrl(url) + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      embed.removeAttribute('hidden');
      poster.style.display = 'none';
    });
  }

  /* ── VIDEO MODAL (thumbnail strip) ── */
  function initVideoModal(section) {
    const thumbs   = section.querySelectorAll('.product-video-thumb');
    const modal    = document.getElementById('ProductVideoModal');
    const embed    = document.getElementById('ProductVideoEmbed');
    const closeBtn = modal ? modal.querySelector('.product-video-modal__close') : null;
    const backdrop = modal ? modal.querySelector('.product-video-modal__backdrop') : null;
    if (!modal || !embed || !thumbs.length) return;

    function openModal(url) {
      embed.innerHTML = '<iframe src="' + getEmbedUrl(url) + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      embed.innerHTML = '';
      document.body.style.overflow = '';
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => { if (thumb.dataset.videoUrl) openModal(thumb.dataset.videoUrl); });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  }

  

  /* ── INIT ── */
  function init() {
    const section = document.querySelector('.main-product');
    if (!section) return;

    [
      initVariants,
      initGallery,
      initZoom,
      initQty,
      initReadMore,
      initAccordions,
      initFeatureVideo,
      initVideoModal
    ].forEach(fn => {
      try {
        fn(section);
      } catch (err) {
        console.error('main-product init failed:', fn.name, err);
      }
    });
  }


  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') init();
    });
  }

})();